import { useMutation, useQueryClient } from '@tanstack/react-query';
import { groupsQueryOptions } from '@/hooks/contacts/use-groups';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import { allChatSessionQueryOptions } from '@/hooks/sessions/use-conversation-sessions';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useJoinGroup(isPrivateGroup = false) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, JoinGroupRequest>({
    mutationKey: [isPrivateGroup ? '/ApplyJoinGroup' : '/JoinGroup'],
    mutationFn: (params) =>
      fetcher(
        isPrivateGroup ? '/ApplyJoinGroup' : '/JoinGroup',
        {
          GroupID: params.groupId,
          ChatID: params.messageId,
        },
        { validResponseCodes: [0] },
      ),
    onSuccess: (_, params) =>
      Promise.allSettled([
        queryClient.invalidateQueries(groupsQueryOptions),
        queryClient.invalidateQueries(generateGroupInfoQueryOptions(params.groupId)),
        queryClient.invalidateQueries(allChatSessionQueryOptions),
      ]),
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}

type JoinGroupRequest = {
  messageId?: number;
  groupId: number;
};
